import React, { useEffect, useState } from "react";
import "../Style/Home.css";
import db from "../firebase";
import Feed from "./Feed";
import Header from "./Header";
import Sidebar from "./Sidebar/Sidebar";
import Widget from "./Widget/Widget";
import { fade, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      maxWidth: "1500px",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },

    justifyContent: "center",
    minWidth: "828px",

    backgroundColor: "rgb(241, 241, 241)",
  },
}));

function Home() {
  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState(null);

  const searchHandler = (event) => {
    const { value } = event.target;
    setFilteredPosts(
      value
        ? posts.filter((post) => post.question.question.includes(value))
        : null
    );
  };

  const categoryFilter = (category = "All") => {
    const filtered =
      category === "All"
        ? posts
        : posts.filter(({ question }) => question.option === category);
    setFilteredPosts(filtered);
  };

  useEffect(() => {
    const getAllQuestionsAndAnswers = async () => {
      const questionsRef = await db
        .collection("questions")
        .orderBy("timestamp", "desc")
        .get();

      const questionsAnswersRef = questionsRef.docs.map((question) =>
        question.ref.collection("answer").orderBy("timestamp", "desc")
      );

      const ans = await Promise.all(questionsAnswersRef.map((el) => el.get()));

      const answers = ans.map((snap) =>
        snap.docs.map((ans) => {
          const data = ans.data();
          if (data) {
            return {
              answerId: ans.id,
              answer: data.answer,
              questionId: data.questionId,
              user: data.user,
              timestamp: data.timestamp,
            };
          }
        })
      );

      setPosts(
        questionsRef.docs.map((doc, index) => ({
          questionId: doc.id,
          question: doc.data(),
          answers: answers[index],
        }))
      );
    };

    getAllQuestionsAndAnswers();
  }, []);

  return (
    <div className="home">
      <div></div>
      <Header searchHandler={searchHandler} categoryFilter={categoryFilter} />
      <div className="home__content">
        <div className={classes.sectionDesktop}>
          <Sidebar categoryFilter={categoryFilter} />
          <Feed posts={filteredPosts || posts} />
          <Widget />
        </div>
        <div className={classes.sectionMobile}>
          <Feed posts={filteredPosts || posts} />
        </div>
      </div>
    </div>
  );
}

export default Home;
